import { bulmaInit, datadogInit } from '../../common';
import './reset-password.scss';

datadogInit();
bulmaInit();
